import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { Icon } from "@/shared";

export const Header = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-b-blue-100 tw-p-6 tw-font-sans tw-text-base tw-font-semibold tw-text-blue-base">
      <span className="tw-inline-flex tw-flex-1">
        General organization customization
      </span>
      <span
        className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-transition-opacity tw-duration-200 hover:tw-opacity-80"
        onClick={() => dispatch(closeDialog("uZknTZTeNMV3lZSLhBSKR"))}
      >
        <Icon icon="ri-close-fill" size={24} color="#88819F" />
      </span>
    </div>
  );
};
